/** @jsx jsx */
import { useState } from 'react';
import { jsx } from '@emotion/core';
import { useTranslation } from 'react-i18next';
import { Box, Grid, InputLabel, useTheme } from '@material-ui/core';

import { MainButton, SwitchButton } from 'components';
import { ICustomTheme } from 'interfaces';

const MobileSorting = ({
  onConfirm,
}: {
  onConfirm: () => void;
}): JSX.Element => {
  const theme: ICustomTheme = useTheme();
  const { t } = useTranslation();
  const [isChecked, setIsChecked] = useState(false);

  const handleSorting = () => {
    setIsChecked((prev) => !prev);
  };

  return (
    <Grid
      container
      justifyContent="center"
      spacing={4}
      css={{ marginTop: theme.spacing(1) }}
    >
      <Grid
        item
        css={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        xs={8}
      >
        <Box>
          <InputLabel shrink>
            {t('challenges.declaration.sortingBy')}
          </InputLabel>
          <SwitchButton
            firstLabel={t('challenges.declaration.increasingProfit')}
            secondLabel={t('challenges.declaration.decreasingProfit')}
            checked={isChecked}
            onClick={handleSorting}
          />
        </Box>
      </Grid>
      <Grid item css={{ display: 'flex', justifyContent: 'center' }} xs={12}>
        <MainButton
          variant="contained"
          css={{ minWidth: 125, borderRadius: 20 }}
          onClick={onConfirm}
        >
          {t('core.close')}
        </MainButton>
      </Grid>
    </Grid>
  );
};
export default MobileSorting;
